import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IOvertimeRequestState } from './overtime-request.types';
import { IOvertimeRequestData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IOvertimeRequestState = {
  version: 1,
  count: 0,
  overtimeRequests: [] as IOvertimeRequestData[],
  comments: [],
  lastCreatedOvertimeRequestCommentId: null,
  mentionableUsers: [],
  activities: [],
  lastPromise: null
};

const namespaced = true;

export const overtimeRequest: Module<IOvertimeRequestState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
